import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { bulk_discover_saved_searches_path } from "~/lib/routes"

// This controller is used to delete the selected saved searches (views).
export default class extends Controller {
  static get values() {
    return {
      selectedViewIds: { type: Array, default: [] }
    }
  }

  // This action is used to update the selected views value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedViewIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedViewIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
    } else {
      this.selectedViewIdsValue = []
    }
  }

  // This action submits a temporary form to delete the selected views.
  submit() {
    let formToSubmit = TempFormHelper.create(bulk_discover_saved_searches_path(), "delete", (form) => {
      this.selectedViewIdsValue.forEach(viewId => { TempFormHelper.addHiddenInput(form, "ids[]", viewId) })
    })
    formToSubmit.requestSubmit()
  }
}

